<div class="ion-page modal-body fixed" scrollY="true">
  <div class="modalInnerWrapper modal-content">
    <div class="modal-body">

      <div class="race-preview shadow p-0 mb-2 mt-4">
        <div class="race-header bg-fill-secondary text-white">
          <div class="race-info">
            <div class="race-name text-uppercase">{{item.betName+" "+item.multiplier+"x"}}</div>
          </div>
        </div>

        <div class="race-content" >
          <div class="table-box" style="overflow: auto;">
            <table class="racing-table table-borderless table-striped">
            
              <tbody *ngFor="let bet of item.bets">
  
                <tr *ngFor="let b of bet.betSelections" class="won">
                  <td class="text-left">{{"("+b.selectionNumber+") "+b.name}}</td>
                  <td class="text-left">{{b.eventCode}}</td>
                  <td>{{b.meetingName}}</td>
                </tr>
  
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
  
              </tbody>
            </table>
          </div>
         
        </div>

      </div>



    </div>
    <!-- <ion-icon class="close icon icon-close" (click)="dismiss()" name="close-sharp"></ion-icon> -->
    <button (click)="dismiss()" type="link" class="close">
      <span class="icon icon-close"></span>
    </button>
  </div>
</div>